import {
  Box, Container, Wrap, Text, List, ListItem,
} from '@chakra-ui/react';
import MainLayout from '@src/components/layouts/main';
import { useRef } from 'react';
import { useIsUserInRole, selectedDatabaseIdState } from '@transport-insights/uikit';
import { useRecoilValue } from 'recoil';
import { Redirect } from 'react-router-dom';
import Pagination from '../../components/Pagination';
import PrintablePdf from '../../components/PrintablePdf';
import NetworkAvailabilityReportHeader from './components/report-headers/NetworkAvailabilityReportHeader';
import DataDisclaimer from '../../components/DataDisclaimer';
import NetworkAvailabilityFreightAccessibilityDistributionOnrc from './components/report-sections/NetworkAvailabilityFreightAccessibilityDistributionOnrc';
import NetworkAvailabilityFreightAccessibilityDistributionStreetCategory from './components/report-sections/NetworkAvailabilityFreightAccessibilityDistributionStreetCategory';
import NetworkAvailabilityFreightAccessibilityDistributionFreight from './components/report-sections/NetworkAvailabilityFreightAccessibilityDistributionFreight';
import NetworkAvailabilityFreightAccessibilityDistributionGeneralTraffic from './components/report-sections/NetworkAvailabilityFreightAccessibilityDistributionGeneralTraffic';
import NetworkAvailabilityResilienceDistributionsOnrc from './components/report-sections/NetworkAvailabilityResilienceDistributionsOnrc';
import NetworkAvailabilityResilienceDistributionsStreetCategory from './components/report-sections/NetworkAvailabilityResilienceDistributionsStreetCategory';
import NetworkAvailabilityResilienceDistributionsFreight from './components/report-sections/NetworkAvailabilityResilienceDistributionsFreight';
import NetworkAvailabilityResilienceDistributionsGeneralTraffic from './components/report-sections/NetworkAvailabilityResilienceDistributionsGeneralTraffic';

function NetworkAvailability() {
  const printableRef = useRef();
  const hasDeveloperRole = useIsUserInRole('Developer');
  const rcaId = useRecoilValue(selectedDatabaseIdState);

  // Only allow access to RCAs excluding State Highways & Doc Roads
  // unless user has Developer role
  if ((rcaId === 81 || rcaId >= 1000 || rcaId === 88) && !hasDeveloperRole) {
    return <Redirect to="/performance/dashboard" />;
  }

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Pagination
          pdfPrint={(
            <PrintablePdf
              fileName="Network Availability and Accessibility"
              printableRef={printableRef}
              printableStyles={null}
            />
          )}
          moreInfo={(
            <>
              <Text mb={4}>The Government Policy Statement on land transport (GPS) for 2024-34 identifies resilience as a key strategic priority.</Text>
              <Text mb={4}>This page provides a range of resilience indicators for the network in the form of:</Text>
              <List listStyleType="disc" mb={4} spacing={2} pl={4}>
                <ListItem>volumes of road traffic impacted by detours due to road closures</ListItem>
                <ListItem>volumes of road traffic affected by road closures where there is no detour in place</ListItem>
                <ListItem>how accessible the network is for heavy vehicles. This contributes to whether heavy-vehicle detours are available for road closures.</ListItem>
              </List>
              <Text>The charts provide statistics on the latest year for different ONF road classifications (Freight, General Traffic and Street Categories) as well as for ONRC.</Text>
            </>
          )}
        />
        <Box ref={printableRef}>
          <NetworkAvailabilityReportHeader />
          <Wrap spacing={2} className="report-sections-wrapper">
            <NetworkAvailabilityResilienceDistributionsOnrc />
            <NetworkAvailabilityResilienceDistributionsStreetCategory />
            <NetworkAvailabilityResilienceDistributionsFreight />
            <NetworkAvailabilityResilienceDistributionsGeneralTraffic />
            <NetworkAvailabilityFreightAccessibilityDistributionOnrc />
            <NetworkAvailabilityFreightAccessibilityDistributionStreetCategory />
            <NetworkAvailabilityFreightAccessibilityDistributionFreight />
            <NetworkAvailabilityFreightAccessibilityDistributionGeneralTraffic />
          </Wrap>
        </Box>
        <DataDisclaimer />
      </Container>
    </MainLayout>
  );
}

export default NetworkAvailability;
